const faviconsContext = require.context(
  `!file-loader?name=[name].[ext]&outputPath=assets/favicons!./${process.env.VUE_APP_AppBrand}` || 'tmx/',
  true,
  /\.(svg|png|ico|xml|json|webmanifest)$/
)

faviconsContext.keys().forEach(faviconsContext)
